import dash_api from '../../../../main/support/dash_api';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';
import type { DataAction } from '../../../types/dataAction.type';
import type { User } from '../types';

const GetUser = new ReduxAsyncAction<'GET_USER', void, User>('GET_USER');

GetUser.registerRequest(function () {
  return dash_api.get('/v1/dashboard-user/by-cookie').then(({ data }) => {
    return data;
  });
});

export const GET_USER = GetUser.actionNamespaceConstants;

export const getUser = GetUser.request;

// for legacy calls
export const loadUser = GetUser.request;

export type GetUserDataResponseAction = DataAction<typeof GET_USER.response, User>;
